import {bodyLock, bodyUnlock} from '@/scripts/components/Overlay';

let miniCart = null;

export function openCart() {
  miniCart = miniCart || document.querySelector('.minicart');

  miniCart.classList.add('minicart--open');

  bodyLock();

  if (window.innerWidth < 750) {
    window.addEventListener('resize', resizeMiniCart);
    resizeMiniCart();
  }
}

export function closeCart() {
  miniCart = miniCart || document.querySelector('.minicart');

  miniCart.classList.remove('minicart--open');
  bodyUnlock();
  window.removeEventListener('resize', resizeMiniCart);
}

function resizeMiniCart() {
  miniCart = miniCart || document.querySelector('.minicart');

  const newHeight = window.innerHeight;

  miniCart.style.height = `${newHeight}px`;
}
